import React from "react";
import CustomInput from "../components/CustomInput";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
// import { toast } from "react-toastify";

const Forgotpassword = () => {
  const submitHandler = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;

    try {
      const res = await axios.post(`${base_url}users/forget-password`, {
        email,
      });
      if (res.data.success === true) {
        e.target.reset();
        // toast.success(res.data.message);
        alert(res.data.message);
      }
      console.log(res.data);
      // alert("Password reset link sent to your email!");
    } catch (error) {
      console.error(error);
      alert(error.response.data.message || error.message || "Something went wrong, please try again.");
    }
  };

  const onChange = (e) => {
    console.log(e.target.value);
  };

  return (
    <div className="py-5" style={{ background: "#ffd333", minHeight: "100vh" }}>
      <div className="my-5 w-25 bg-white rounded-3 mx-auto p-4">
        <h3 className="text-center title">Forgot Password</h3>
        <p className="text-center">
          Please enter your registered email to get reset password link.
        </p>
        <form onSubmit={submitHandler}>
          <CustomInput
            type="email"
            label="Email Address"
            id="email"
            name="email"
            onChange={onChange}
            required
          />

          <button
            className="border-0 px-3 py-2 text-white fw-bold w-100 mt-3"
            style={{ background: "#ffd333" }}
            type="submit"
          >
            Send Link
          </button>
        </form>
      </div>
    </div>
  );
};

export default Forgotpassword;
